module.exports = __webpack_public_path__ + "img/icon_checkbox_checked.9ceb64ce.svg";